import {observe} from '@github-ui/selector-observer'

let ital = 10
let width = 125

observe('.js-font-playground', observed => {
  const playground = observed as HTMLElement
  const target = playground.querySelector<HTMLElement>('.js-font-slider-target')
  if (!(target instanceof HTMLElement)) return

  const weightSlider = playground.querySelector<HTMLInputElement>('.js-font-slider-weight')
  weightSlider?.addEventListener('input', () => {
    target.style.fontWeight = weightSlider.value
  })

  const widthSlider = playground.querySelector<HTMLInputElement>('.js-font-slider-width')
  widthSlider?.addEventListener('input', () => {
    width = parseInt(widthSlider.value)
    target.style.fontVariationSettings = `'ital' ${ital}, 'wdth' ${width}`
  })

  const italicsSlider = playground.querySelector<HTMLInputElement>('.js-font-slider-italics')
  italicsSlider?.addEventListener('input', () => {
    ital = parseInt(italicsSlider.value)
    target.style.fontVariationSettings = `'ital' ${ital}, 'wdth' ${width}`
  })
})

const typeGridStretchMax = 125
const typeGridStretchMin = 75
const typeGridWeightMax = 900
const typeGridWeightMin = 200

observe('.js-typegrid', observed => {
  const typegrid = observed as HTMLElement
  const typeGridChars = typegrid.querySelectorAll('div')
  let typeGridRect = typegrid.getBoundingClientRect()
  const typeGridCharRects = Array.from(typeGridChars).map(char => char.getBoundingClientRect())
  let scrollOffset = 0

  function updateRects() {
    typeGridRect = typegrid.getBoundingClientRect()
    // Loop over type grid chars and get all their client rects
    for (let i = 0; i < typeGridChars.length; i++) {
      /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
      typeGridCharRects[i] = typeGridChars[i]!.getBoundingClientRect()
    }
    scrollOffset = window.scrollY
  }

  typegrid.addEventListener('mouseenter', updateRects)
  // Use a resize observer to update the type grid rects
  const resizeObserver = new ResizeObserver(updateRects)
  resizeObserver.observe(typegrid)

  // Add an event listener for mouse movements and get the local coordinates
  typegrid.addEventListener('mousemove', event => {
    // Calculate the stretch and weight values for all typeGridChars
    for (let i = 0; i < typeGridCharRects.length; i++) {
      /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
      const charRect = typeGridCharRects[i]!
      const distanceFromMouseX = Math.abs(event.clientX - (charRect.left + charRect.width / 2))
      const distanceFromMouseY = Math.abs(event.pageY - (charRect.top + charRect.height / 2 + scrollOffset))
      const distancePercentX = distanceFromMouseX / typeGridRect.width
      const distancePercentY = distanceFromMouseY / typeGridRect.height
      const stretch =
        typeGridStretchMin + (typeGridStretchMax - typeGridStretchMin) * (1 - distancePercentX) * (1 - distancePercentX)
      const weight =
        typeGridWeightMin + (typeGridWeightMax - typeGridWeightMin) * (1 - distancePercentY) * (1 - distancePercentY)
      /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
      typeGridChars[i]!.style.fontWeight = `${Math.round(clamp(weight, typeGridWeightMin, typeGridWeightMax))}`
      /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
      typeGridChars[i]!.style.fontStretch = `${Math.round(clamp(stretch, typeGridStretchMin, typeGridStretchMax))}%`
    }
  })
})

function clamp(number: number, min: number, max: number) {
  return Math.max(min, Math.min(number, max))
}
